// src/components/common/Button.js - Reusable button component
import React from 'react';
import styled, { css } from 'styled-components';

const ButtonStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.size === 'small' 
    ? 'var(--spacing-xs) var(--spacing-sm)' 
    : props.size === 'large' 
      ? 'var(--spacing-md) var(--spacing-lg)'
      : 'var(--spacing-sm) var(--spacing-md)'
  };
  font-size: ${props => props.size === 'small' 
    ? '0.875rem' 
    : props.size === 'large' 
      ? '1.125rem'
      : '1rem'
  };
  font-weight: 500;
  border-radius: 20px; /* Rounded buttons like Aranscia's site */
  cursor: pointer;
  transition: all var(--transition-speed) ease;
  gap: var(--spacing-sm);
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const PrimaryButton = styled.button`
  ${ButtonStyles}
  background-color: #f45d22; /* Aranscia orange */
  color: white;
  border: none;
  
  &:hover:not(:disabled) {
    background-color: var(--primary-dark);
  }
  
  &:focus {
    outline: 2px solid var(--primary-light);
    outline-offset: 2px;
  }
`;

const SecondaryButton = styled.button`
  ${ButtonStyles}
  background-color: transparent;
  color: #f45d22; /* Aranscia orange */
  border: 2px solid #f45d22; /* Increased from 1px to 2px for better visibility */
  
  &:hover:not(:disabled) {
    background-color: rgba(244, 93, 34, 0.1);
  }
  
  &:focus {
    outline: 2px solid var(--primary-light);
    outline-offset: 2px;
  }
`;

const TertiaryButton = styled.button`
  ${ButtonStyles}
  background-color: transparent;
  color: var(--text-color);
  border: none;
  
  &:hover:not(:disabled) {
    background-color: var(--background-light);
  }
  
  &:focus {
    outline: 2px solid var(--background-dark);
    outline-offset: 2px;
  }
`;

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  type = 'button',
  disabled = false,
  onClick,
  ...props 
}) => {
  const ButtonComponent = 
    variant === 'secondary' ? SecondaryButton :
    variant === 'tertiary' ? TertiaryButton :
    PrimaryButton;
    
  return (
    <ButtonComponent
      type={type}
      size={size}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </ButtonComponent>
  );
};

export default Button; 